<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2024-04-28 10:56:56
 * @LastEditors: sjq
 * @LastEditTime: 2025-12-01 09:45:23
 -->
<template>
  <div class="continer_box">
    <div class="pay-success container-box">
      <!-- 菜单栏（内嵌App时隐藏） -->
      <app-header :title="title" :transparent="false" back-type="back-app" :leftStyle="isWxk ? 'color:#000' : ''" />
      <!-- 购买成功 -->
      <div class="container-bg">
        <img class="bg" src="../../../images/payment/add_teacher_bg.png" alt="" />
        <div class="ctext">
          <div class="main-title">{{ payStatus.mainTitle || '恭喜您！购买成功' }}</div>

          <div class="second-title">{{ payStatus.secondTitle || '快去友邻少年APP学习吧' }}</div>
          <div class="qr-box">
            <img class="img" :src="payStatus.adviserCode || defaultAdviserImg" />
            <div v-if="payStatus.adviserName" class="img-text">
              {{ payStatus.adviserName || '' }}
            </div>
            <div
              class="btn-common"
              v-if="!appUser.isWeixin"
              @click="!appUser.isNative ? getUrlScheme() : nativeGoMini()"
            >
              立即添加
            </div>
            <div v-else class="long-tap-box">长按图片，扫一扫添加</div>
          </div>
          <div class="note-box" v-if="payStatus.note">
            <div class="note-main">
              <div class="note-title">获得专属福利</div>
              <div class="note-content">
                <div v-html="payStatus.note"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="logo-img">
          <img src="../../../images/logo2.png" mode="widthFix" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 商品订单的成功页面
import { mapGetters } from 'vuex'
import Body from '@/mixins/body'
import PayUser from './components/pay-user'
import { appUser } from '@/utils'
import goWeixin from '@/utils/goWeixin'
import { $gotoMiniProgramV2 } from '@/utils/common/native-api'

export default {
  name: 'pay-success',
  components: { PayUser },
  mixins: [Body],
  data() {
    return {
      title: '友邻少年',
      isImg: false,
      appUser
    }
  },
  computed: {
    ...mapGetters('payment/order', [
      'payStatus' // 支付状态
    ]),
    ...mapGetters('goods/vip', ['isNeedAuthentic']),
    ...mapGetters('args', ['fromIntegral']),
    to() {
      return { name: 'confirmOrder' }
    },
    goodsId() {
      return this.$route.params.id
    },
    // 是否是指定无限卡
    isWxk() {
      let equityType = ['renewal', 'renewal_year', 'forever']
      return (
        this.payStatus.goodsType === '50001' && equityType.findIndex(item => item === this.payStatus.equityType) !== -1
      )
      // let goodsList = appUser.isTestEnv ? [104314] : [109298, 109505, 109517]
      // return goodsList.findIndex(item => item === this.payStatus.goodsId * 1) !== -1
    }
  },
  activated() {
    const { goodsId } = this
    this.$store.commit('payment/order/getPayStatus', { goodsId })
    try {
      // 调用IOS的方法 允许左滑手势
      const bridge = window.WebViewJavascriptBridge
      if (bridge) {
        bridge.send('allowsBackForwardGestures', 'disable')
      }
    } catch (e) {
      console.log(e)
    }
    document.title = this.payStatus.title
    console.log(this.fromIntegral)
    console.log(this.payStatus, goodsId, 'payStatus')
  },
  methods: {
    isNative() {
      return appUser.isNative
    },
    getUrlScheme() {
      console.log(appUser, this.user, 'this.user.userId')
      let adviserCode = this.user.adviserCode || this.defaultAdviserImg
      let data = {
        goodsType: this.user.goodsType,
        goodsId: this.user.goodsId,
        adviserCode: adviserCode
      }

      goWeixin(1, data)
    },
    nativeGoMini(event) {
      this.$store.dispatch('user/login/getMiniParam', {}).then(mini => {
        $gotoMiniProgramV2({
          miniUserName: mini.miniUserName,
          goMiniUrl:
            'pages/rights_receive/app_add_headTeacher/app_add_headTeacher?userId=' + appUser.userId + '&sceneId=3'
        })
      })
    }
  },
  mounted() {
    // setTimeout(() => {
    //   this.isImg = true
    // }, 1000)
    this.$nextTick(() => {
      this.isImg = true
    })
  }
}
</script>

<style lang="scss" scoped>
.continer_box {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f7f9fb;
  min-height: 100vh;
  background: #00b25a;
}
.pay-success {
  background: #00b25a;
}
.container-box {
  .container-bg {
    margin: 0 0.48rem;
    position: relative;
    padding-bottom: 2.4rem;
    .bg {
      position: absolute;
      width: 100%;
      left: 0;
      right: 0;
    }
    .ctext {
      position: relative;
      padding-top: 3.2rem;
      text-align: center;
      color: #ffffff;
      .main-title {
        font-size: 0.4rem;
        font-weight: bold;
        margin-bottom: 0.32rem;
      }
      .second-title {
        margin-bottom: 0.5rem;
        opacity: 0.7;
      }
      .qr-box {
        margin: 1.4rem 0;
        img {
          width: 3.2rem;
          // margin: 0 auto 0.48rem;
        }
        .img-text {
          color: #00b25a;
          margin-bottom: 0.32rem;
        }
        .long-tap-box {
          color: #999;
        }
      }
      .note-box {
        margin-top: 1.2rem;
        border-radius: 0.32rem;
        border: 1px solid rgba(255, 255, 255, 0.3);
        background: rgba(255, 255, 255, 0.3);
        padding: 0.16rem;
        margin-bottom: 0.48rem;
        .note-main {
          background: #fff;
          color: #999;
          border-radius: 0.32rem;
          text-align: left;
          padding: 0.32rem;
          .note-title {
            color: #00b25a;
            font-size: 0.32rem;
            font-weight: bold;
          }

          .note-content {
            line-height: 1.5;
            white-space: break-spaces;
            margin-top: 0.24rem;
          }
        }
      }
    }
    .logo-img {
      position: absolute;
      bottom: 0.64rem;
      left: 0;
      right: 0;
      text-align: center;
      img {
        width: 2rem;
      }
    }
  }
}
.btn-common {
  margin: 0 24px;
}
</style>
